<template>
  <div class="coupon-pop-page"> 
    <div class="choose-coupon" v-if="visible">
      <img :src="CloseIcon" class="closeIcon"  @click="hideChooseCoupon">
      <div class="page-title">优惠券</div>
      <div class="top-tips" @click="handleShowDesc">
        <img src="https://image.xiaomaiketang.com/xm/tFSDrPywFH.png" alt class="question-icon" />
        <span class="top-tips-text">优惠券使用说明</span>
      </div>
      <div class="coupon-list">
        <CouponItem
          :item="item"
          v-for="(item,key) in validCouponList"
          :key="item.userCouponId"
          @showExplain="handleShowExPlain"
          :canChoose="true"
          :chooseCoupon="chooseCoupon"
          @clickCoupon="handleChooseCoupon"
          :version="'new'"
        ></CouponItem>
        <div class="invalid-divide" v-if="invalidCouponList.length > 0">—— 以下此订单不适用 ——</div>
        <CouponItem
          :item="item"
          v-for="(item,key) in invalidCouponList"
          :key="item.userCouponId"
          @showExplain="handleShowExPlain"
          :used="true"
          :showUsed="false"
          :version="'new'"
        ></CouponItem>
        <div class="invalid-divide">没有更多优惠券了</div>
        
      </div>
      <div class="not-use-btn" @click="handleChooseCoupon({})">不使用优惠券</div>
    </div>
    <CouponDetailModal
      :visible="showDetailModal"
      :detail="couponDetail"
      @close="handleCloseExPlain"
    />
    <CouponDescModal :visible="showDescModal" @close="handleHideDesc" />
 </div> 
</template>

<script>
import CouponItem from "@/module/benefits/CouponItem";
import CouponDetailModal from "@/module/benefits/CouponDetailModal";
import CouponDescModal from "@/module/benefits/CouponDescModal";
import CloseIcon from "@/images/close.png";
export default {
  components: {
    CouponItem,
    CouponDetailModal,
    CouponDescModal
  },
  props: {
    visible: false,
    validCouponList: Array, // 可使用的优惠券
    invalidCouponList: Array, // 不可用的优惠券
    chooseCoupon: Object // 选择的优惠券
  },

  data() {
    return {
      showDetailModal: false,
      showDescModal: false,
      couponDetail: {},
      CloseIcon
    };
  },

  methods: {
    handleChooseCoupon(item) {
      this.$emit("chooseEvent", item);
    },

    handleShowExPlain(item) {
      this.showDetailModal = true;
      this.couponDetail = item;
    },

    handleCloseExPlain() {
      this.showDetailModal = false;
    },

    handleShowDesc() {
      this.showDescModal = true;
    },

    handleHideDesc() {
      this.showDescModal = false;
    },
    hideChooseCoupon(){
      this.$emit("hideChooseCoupon");
    }
  }
};
</script>

<style lang="less">
.coupon-pop-page{


.choose-coupon {
  // position: fixed;
  // top: 0;
  // left: 0;
  // right: 0;
  // bottom: 0;
  // overflow-y: auto;
  // padding-bottom: 0.88rem;
  // -webkit-overflow-scrolling: touch;
  // background: #fafafa;
  // text-align: left;
  width:100vw;
  max-height:66vh;
  overflow-y: auto;
  border-radius: 0.2rem 0.2rem 0 0;
  .page-title{
    text-align:left;
    font-size:0.3rem;
    color:rgba(51,51,51,1);
    line-height:0.88rem;
    // padding:0.22rem 0.32rem;
    border:0.2rem 0.2rem 0 0;
    border-bottom:1px solid #eee;
    position:absolute;
    height:0.88rem;
    background:#FFF;
    width:100%;
    padding-left:0.32rem;
    z-index:1000;
    border-radius: 0.2rem 0.2rem 0 0;
  }
  .top-tips {
    width: 100%;
    background:rgba(255,105,52,0.2);
    display: flex;
    align-items: center;
    margin-top:0.88rem;
    .question-icon {
      width: 0.26rem;
      height: 0.26rem;
      margin-right: 0.16rem;
      margin-left: 0.32rem;
    }
    .top-tips-text {
      height: 0.6rem;
      line-height: 0.6rem;
      color: #FF6934;
      font-size: 0.26rem;
    }
  }
  .coupon-list {
    padding: 0.3rem 0.32rem;
    background:rgba(244,245,250,1);
  }
  .invalid-divide {
    text-align: center;
    margin: 0.4rem 0 0.5rem 0;
    font-size: 0.26rem;
    color: #666;
  }
  .not-use-btn {
    height: 0.88rem;
    line-height: 0.88rem;
    background: #fff;
    color: #FF6934;
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1111;
  }
  .closeIcon {
    position: absolute;
    right: 0.32rem;
    top: 0.26rem;
    color:#999;
    z-index:1001;
    width:0.25rem;
    height:0.25rem;
    display:inline-block;
  }
}
.coupon-detail-modal-mask{
    position: absolute;
    left: 0;
    right: 0;
    top:auto;
    bottom: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10001;
    .coupon-detail-modal{
      width: 5.4rem;
      height: 6.4rem;
      border-radius: 0.24rem;
      background-color: #fff;
      margin-top: 2.2rem;
      position: absolute;
      padding-top: 0.32rem;
      left: calc(~"50vw - 2.7rem");
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/module/mall/ChooseCouponV5.vue